<template>
    <v-container>
        <v-row>
            <v-col lg="7" cols="12">
                <div class="d-flex align-center">
                    <div class="headline">Leveranse</div>
                    <div class="mx-2"></div>
                    <v-btn v-if="deliveryDelivered && !loading" color="success" small @click="changeDelivered(0)">
                        <v-icon left>mdi-truck-check</v-icon>
                        levert
                    </v-btn>

                    <v-btn v-if="!deliveryDelivered && !loading" color="primary" small @click="changeDelivered(1)">
                        <v-icon left>mdi-truck</v-icon>
                        ikke levert
                    </v-btn>
                </div>

                <!-- <div>Eier (kan ikke endres): {{this.delivery.createdBy.name}}</div> -->
                <v-form>
                    <v-text-field v-model="delivery.name" label="Emne*"></v-text-field>
                    <v-text-field v-model="delivery.description" label="Beskrivelse"></v-text-field>
                    <v-autocomplete v-model="delivery.supplier" :items="suppliers" item-text="name" item-value="id" return-object label="Leverandør*"></v-autocomplete>
                    <v-autocomplete v-model="delivery.contactPersons" :items="users" item-text="name" item-value="id" multiple return-object label="Kontaktpersoner* - mottar info vedr. leveranse på e-post"></v-autocomplete>
                    <v-autocomplete v-model="delivery.users" :items="users" item-text="name" item-value="id" return-object multiple label="Mottaksansvarlig på byggeplass (BAS)"></v-autocomplete>
                    <v-select v-model="delivery.zone" :items="zones" item-text="name" item-value="id" return-object label="Sone*"></v-select>

                    <v-data-table :items="resources" :headers="resourceHeaders" hide-default-footer disable-pagination :mobile-breakpoint="0" dense class="elevation-1 pa-1">
                        <template v-slot:top> Ressurser </template>
                        <template v-slot:item.name="{ item }">
                            <v-chip pill>
                                <v-avatar :class="item.color" left></v-avatar>
                                {{ item.name }}
                            </v-chip>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn @click="decreaseResourceUsage(item)" icon color="primary">
                                <v-icon>mdi-minus-circle</v-icon>
                            </v-btn>
                            <v-btn @click="increaseResourceUsage(item)" icon color="primary">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-form>

                <br />

                <div v-if="id > 0 && (this.delivery.inAccessCode || this.delivery.outAccessCode)" class="body-1 grey lighten-2">
                    Koder: send kode <span class="font-weight-bold"> {{ (this.delivery.inAccessCode || this.delivery.outAccessCode).code }}</span> som SMS til følgende porter:
                    <v-row no-gutters>
                        <v-col>
                            <div>INNGANG</div>
                            <ul>
                                <li v-for="gate in this.delivery.zone.gates.filter((g) => g.direction == 0 || g.direction == 2)" :key="gate.id">{{ gate.name }}: +47 {{ gate.unit && gate.unit.simcard && gate.unit.simcard.number ? gate.unit.simcard.number : "ingen nummer" }}</li>
                            </ul>
                        </v-col>
                        <v-col>
                            <div>UTGANG</div>
                            <ul>
                                <li v-for="gate in this.delivery.zone.gates.filter((g) => g.direction == 1 || g.direction == 2)" :key="gate.id">{{ gate.name }}: +47 {{ gate.unit && gate.unit.simcard && gate.unit.simcard.number ? gate.unit.simcard.number : "ingen nummer" }}</li>
                            </ul>
                        </v-col>
                    </v-row>
                </div>

                <br />

                <div class="d-flex">
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="warning lighten-2">nullstille</v-btn> -->
                    <v-btn @click="save" color="primary lighten-2" class="mx-2" :disabled="!canSave || isSaving">
                        <v-icon left>mdi-content-save</v-icon>
                        lagre
                    </v-btn>
                    <v-btn @click="showDeleteDialog = true" color="error lighten-2" :disabled="!canDelete">
                        <v-icon left>mdi-delete</v-icon>
                        slett
                    </v-btn>
                </div>

                <br />

                <div style="cursor: pointer">
                    <v-carousel>
                        <v-carousel-item v-for="siteplan in siteplans" :key="siteplan">
                            <v-progress-linear v-if="!siteplan.src" indeterminate></v-progress-linear>
                            <v-img
                                v-if="/^data:image\/.*/.test(siteplan.src) && !!siteplan.src"
                                :src="siteplan.src"
                                contain
                                height="100%"
                                width="100%"
                                @click.stop="
                                    () => {
                                        content = siteplan;
                                        contentShow = true;
                                    }
                                "
                            ></v-img>

                            <iframe v-if="/^data:application\/pdf.*/.test(siteplan.src) && !!siteplan.src" :src="`${siteplan.url}#view=fit&toolbar=0`" allowfullscreen="true" height="100%" width="100%" style="height: -webkit-fill-available; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none"></iframe>
                        </v-carousel-item>
                    </v-carousel>
                </div>

                <v-dialog
                    v-model="contentShow"
                    @keydown.esc="
                        () => {
                            contentShow = false;
                            contentFullscreen = false;
                        }
                    "
                >
                    <div v-if="content && content.name" style="max-height: 90vmin; background: white; position: relative">
                        <div style="position: absolute; background: rgba(255, 255, 255, 0.65); z-index: 10" class="ma-2 pa-2 text-h6">{{ /.*\/.*\/(.*)/.exec(content.name)[1] }}</div>
                        <div style="position: absolute; top: 10px; right: 10px; z-index: 10; display: flex; flex-direcion: row">
                            <v-btn
                                fab
                                small
                                color="rgba(255,255,255,0.65)"
                                style="position: sticky"
                                @click="
                                    () => {
                                        contentFullscreen = !contentFullscreen;
                                    }
                                "
                            >
                                <v-icon v-if="contentFullscreen">mdi-fullscreen-exit</v-icon>
                                <v-icon v-else>mdi-fullscreen</v-icon>
                            </v-btn>
                            <div class="mx-1"></div>
                            <v-btn
                                fab
                                small
                                color="rgba(255,255,255,0.65)"
                                style="position: sticky"
                                @click="
                                    () => {
                                        contentShow = false;
                                        contentFullscreen = false;
                                    }
                                "
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>

                        <v-img v-if="!contentFullscreen" :src="content.src" class="ma-auto" max-height="90vmin" max-width="90vmin" :contain="!contentFullscreen"></v-img>
                        <v-img v-else :src="content.src" class="ma-auto"></v-img>
                    </div>
                </v-dialog>
            </v-col>
            <v-col lg="5" cols="12">
                <div class="d-flex">
                    <v-menu :close-on-content-click="true" transition="scale-transition" offset-y max-width="290px" max-height="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="deliveryDateFormatted" label="Ønsket leveringsdato" prepend-inner-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="deliveryDate" no-title @input="menu2 = false" first-day-of-week="1" show-week :weekday-format="(x) => moment(x).format('dd')" :header-date-format="(x) => moment(x).format('MMM')" :month-format="(x) => moment(x).format('MMM')"></v-date-picker>
                    </v-menu>
                    <v-btn
                        @click="
                            () => {
                                this.deliveryDate = moment().format('YYYY-MM-DD');
                            }
                        "
                        color="primary"
                        class="ml-4"
                        style="align-self: center"
                        >i dag</v-btn
                    >
                </div>

                <div class="d-flex">
                    <v-text-field v-model="deliveryStartTime" label="fra" type="time"></v-text-field>
                    <v-divider vertical inset class="mx-5"></v-divider>
                    <v-text-field v-model="deliveryEndTime" label="til" type="time"></v-text-field>
                    <v-divider vertical inset class="mx-5"></v-divider>
                    <div class="d-flex flex-column">
                        <v-btn @click="earlierDelivery" fab x-small color="primary">
                            <v-icon>mdi-chevron-up</v-icon>
                        </v-btn>
                        <v-btn @click="laterDelivery" fab x-small color="primary mt-1">
                            <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </div>
                </div>

                <br />

                <span class="body-1">Kalender</span>
                <div>
                    <v-calendar
                        class="elevation-1"
                        :start="deliveryDate"
                        @click:event="click"
                        @mouseleave:event="mouseleave"
                        :month-format="monthFormat"
                        :weekday-format="weekdayFormat"
                        :interval-format="
                            (info) => {
                                return info.time;
                            }
                        "
                        ref="cal"
                        style="height: 720px"
                        interval-height="48"
                        :event-overlap-mode="overlapMode"
                        :event-overlap-threshold="overlapThreshold"
                        :events="deliveryEvents"
                        :type="calendarType"
                        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                        :min-weeks="1"
                        :max-days="7"
                        color="primary"
                        :event-more="true"
                        event-more-text="{0} flere"
                    >
                        <template v-slot:event="{ event }">
                            <div class="fill-height" :style="{ background: eventStyleBackground(event), border: eventStyleBorder(event) }">
                                <div class="d-flex" :style="{ 'align-items': 'flex-start' }">
                                    <!-- <v-icon color="white" small>mdi-map-marker</v-icon> -->

                                    <div v-if="calendarLoading && event.delivery.id == id" style="postion: absolute">
                                        <v-progress-circular indeterminate size="14" width="3"> </v-progress-circular>
                                    </div>

                                    <div :style="{ opacity: calendarLoading && event.delivery.id == id ? '50%' : '100%' }">
                                        <span class="body-2">{{ event.delivery.zone.name }}</span>
                                        <v-icon color="white" small class="ml-2">mdi-truck</v-icon>
                                        <span class="body-2 ml-1">{{ event.delivery.name }}</span>
                                    </div>
                                </div>
                                <div :style="{ opacity: calendarLoading && event.delivery.id == id ? '50%' : '100%' }">
                                    {{ moment(event.start).format("HH:mm") }} til {{ moment(event.end).format("HH:mm") }}
                                    <v-icon v-if="event.delivery.resources.some((r) => r.usage > 0)" color="white" small>mdi-wrench</v-icon>
                                </div>
                            </div>
                        </template>
                    </v-calendar>
                    <!-- <v-progress-circular v-if="calendarLoading" indeterminate>

                    </v-progress-circular> -->
                    <!-- <v-overlay :value="calendarLoading" :absolute="true">
                        <v-btn @click="calendarLoading = false"></v-btn>
                    </v-overlay> -->
                </div>
            </v-col>
        </v-row>

        <v-dialog v-model="showDeleteDialog" :width="$vuetify.breakpoint.mdAndUp ? '40%' : '90%'">
            <v-card>
                <v-card-title> Slett leveranse: {{ this.delivery.name }} </v-card-title>
                <v-card-text> Er du sikker du vil slette leveransen? </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error lighten-2" @click="deleteDelivery">
                        <v-icon left>mdi-delete</v-icon>
                        Slett
                    </v-btn>
                    <v-btn @click="showDeleteDialog = false"> Avbryt </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="calendarSnackbar.show" :color="calendarSnackbar.color" bottom right :timeout="2000">
            <div v-if="typeof calendarSnackbar.text == 'object' && 'event' in calendarSnackbar.text">
                <div>Sone: {{ calendarSnackbar.text.event.delivery.zone.name }}</div>
                <div>Emne: {{ calendarSnackbar.text.event.delivery.name || "-" }}</div>
                <div>Tidsluke: {{ moment(calendarSnackbar.text.event.start).format("HH:mm") || "-" }} til {{ moment(calendarSnackbar.text.event.end).format("HH:mm") || "-" }}</div>
            </div>
            <div v-else>
                {{ calendarSnackbar.text }}
            </div>
        </v-snackbar>
    </v-container>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
import colors from "vuetify/lib/util/colors";
export default {
    props: ["id"],
    data() {
        return {
            deliveryDelivered: false,
            deliveryDate: moment().format("YYYY-MM-DD"),
            deliveryStartTime: "12:00",
            deliveryEndTime: "13:00",
            delivery: null,
            deliveryEvent: null,
            deliveries: [],
            deliveryEvents: [],
            users: [],
            suppliers: [],
            zones: [],
            resources: [],
            resourceHeaders: [
                { text: "Navn", value: "name" },
                { text: "Tilgjengelig", value: "available" },
                { text: "Bruk", value: "usage" },
                { text: "Handlinger", value: "actions" },
            ],
            calendarType: "day",
            overlapMode: "stack",
            overlapThreshold: 15,
            loading: false,
            deliveryStartTimeTimeout: undefined,
            deliveryEndTimeTimeout: undefined,
            calendarLoading: false,
            showDeleteDialog: false,
            calendarSnackbar: {
                text: "",
                color: "success",
                show: false,
            },
            isSaving: false,
            contentFullscreen: false,
            contentShow: false,
            content: {
                name: undefined,
            },
        };
    },
    computed: {
        deliveryDateFormatted() {
            return moment(this.deliveryDate).format("Do MMM YYYY");
        },
        canSave() {
            if (this.loading) {
                return false;
            }

            let hasName = !!this.delivery.name;
            let hasSuppier = !!this.delivery.supplier && this.delivery.supplier.id > 0;
            let hasContactPersons = !!this.delivery.contactPersons && this.delivery.contactPersons.length > 0;
            let hasZone = this.delivery.zone && this.delivery.zone.id > 0;

            let hasConflicts = this.deliveryEvent && this.deliveryEvent.conflict;

            return hasName && hasSuppier && hasContactPersons && hasZone && !hasConflicts;
        },
        canDelete() {
            return this.id > 0;
            // if(this.loading){
            //     return false;
            // }
            // return this.id > 0;
        },
        siteplans() {
            return this.$store.getters.filesByType("siteplans");
        },
        canMarkAsDelivered() {
            return this.id > 0 && this.delivery.inAccessCode && this.delivery.inAccessCode.claims === 0;
        },
        canMarkAsNotDelivered() {
            return this.id > 0 && this.delivery.inAccessCode && this.delivery.inAccessCode.claims === 1;
        },
    },
    methods: {
        eventStyleBorder(event) {
            let color;
            let lineStyle;
            let lineWidth;
            if (event && event.conflict) {
                lineWidth = "2px";
                lineStyle = "dashed";
                color = "red";
            } else {
                lineWidth = "0px";
                lineStyle = "none";
                color = "white";
            }
            return `${lineWidth} ${lineStyle} ${color}`;
        },
        eventStyleBackground(event) {
            let baseColor;

            if (event.delivery.zone.color.includes(" ")) {
                baseColor = event.delivery.zone.color.split(" ")[0];
                // let c_sub = event.delivery.zone.color.split(" ")[1].replace("-","");
            } else {
                baseColor = event.delivery.zone.color;
            }

            let color = colors[baseColor]["lighten1"];
            let stripeColor = colors[baseColor]["lighten3"];
            return Number(event.delivery.id) == Number(this.id) ? `repeating-linear-gradient(45deg,${color},${color} 10px,${stripeColor} 10px,${stripeColor} 20px)` : color;
        },
        increaseResourceUsage(resource) {
            if (resource.usage == resource.available) {
                return;
            }
            resource.usage++;
        },
        decreaseResourceUsage(resource) {
            if (resource.usage == 0) {
                return;
            }
            resource.usage--;
        },
        click(e) {
            if (!e.nativeEvent.srcElement.offsetParent.style.zIndex || e.nativeEvent.srcElement.offsetParent.style.zIndex === "0") {
                e.nativeEvent.srcElement.offsetParent.style.zIndex = "1";
            } else {
                e.nativeEvent.srcElement.offsetParent.style.zIndex = "0";
            }

            this.calendarSnackbar.text = {
                event: e.event,
            };
            // this.snackbar.text = `${e.event.delivery.zone.name} -> ${e.event.delivery.name} -> ${moment(e.event.start).format("HH:mm")} til ${moment(e.event.end).format("HH:mm")}`;
            this.calendarSnackbar.color = e.event.delivery.zone.color;
            this.calendarSnackbar.show = true;
            // console.log(e);
        },
        mouseleave(e) {
            e.nativeEvent.stopPropagation();
            e.nativeEvent.srcElement.style.zIndex = "0";
            // console.log(e);
        },
        monthFormat(x) {
            return moment(x.date).format("MMM");
        },
        weekdayFormat(x) {
            return moment(x.date).format("dd");
        },

        createDelivery() {
            let delivery = {
                id: 0,
                name: "",
                description: "",
                supplier: null,
                contactPersons: [],
                users: [],
                zone: {
                    name: "ingen sone",
                    color: "red",
                },
                resources: [],
                start: moment().hour(12).minute(0).unix(),
                end: moment().hour(13).minute(0).unix(),
            };
            return delivery;
        },
        async downloadDelivery(id) {
            let response = await axios.get(`/delivery/${id}`);

            let delivery = response.data.data;
            this.deliveryDelivered = delivery.inAccessCode && delivery.inAccessCode.claims > 0;

            return delivery;
        },
        convertDeliveryToEvent(delivery) {
            let event = {
                delivery: delivery,
                start: moment.unix(delivery.start).format("YYYY-MM-DD HH:mm"),
                end: moment.unix(delivery.end).format("YYYY-MM-DD HH:mm"),
            };
            return event;
        },
        async downloadDeliveries(dateAsString, deliveryId) {
            let response = await axios.get(`/delivery`, {
                params: {
                    start: moment(dateAsString).startOf("day").unix(),
                    end: moment(dateAsString).endOf("day").unix(),
                },
            });

            return response.data.data.filter((d) => d.id != deliveryId);
        },
        convertDeliveriesToEvents(deliveries) {
            let events = deliveries.map((d) => {
                return {
                    delivery: d,
                    start: moment.unix(d.start).format("YYYY-MM-DD HH:mm"),
                    end: moment.unix(d.end).format("YYYY-MM-DD HH:mm"),
                };
            });
            return events;
        },
        async downloadSuppliers() {
            let response = await axios.get(`/supplier`);
            return response.data.data;
        },
        async downloadUsers() {
            let response = await axios.get(`/user`);
            return response.data.data;
        },
        async downloadZones() {
            let response = await axios.get(`/zone`);
            return response.data.data;
        },
        async downloadResources() {
            let response = await axios.get(`/resource`);
            return response.data.data;
        },
        checkConstraints() {
            let start = moment(`${this.deliveryDate} ${this.deliveryStartTime}`).unix();
            let end = moment(`${this.deliveryDate} ${this.deliveryEndTime}`).unix();

            let conflict = this.deliveries.some((d) => {
                let timeConstraint = start < d.end && end > d.start;
                let zoneConstraint = timeConstraint && d.zone.id === this.delivery.zone.id && !this.delivery.zone.multiBook;
                let resourceConstraint = false;

                resourceConstraint = this.resources.some((r) => {
                    let resource = d.resources.find((_r) => _r.id === r.id);
                    if (!resource) return false;
                    return resource.usage + r.usage > r.available;
                });

                return timeConstraint && (zoneConstraint || resourceConstraint);
            });

            if (this.deliveryEvent) {
                this.$set(this.deliveryEvent, "conflict", conflict);
                // this.deliveryEvent.conflict = conflict;
            }

            // console.log(conflict);
        },
        earlierDelivery() {
            this.deliveryStartTime = moment(`${this.deliveryDate} ${this.deliveryStartTime}`).subtract(30, "minute").format("HH:mm");
            this.deliveryEndTime = moment(`${this.deliveryDate} ${this.deliveryEndTime}`).subtract(30, "minute").format("HH:mm");
        },
        laterDelivery() {
            this.deliveryStartTime = moment(`${this.deliveryDate} ${this.deliveryStartTime}`).add(30, "minute").format("HH:mm");
            this.deliveryEndTime = moment(`${this.deliveryDate} ${this.deliveryEndTime}`).add(30, "minute").format("HH:mm");
        },
        async changeDelivered(isDelivered) {
            if (this.id > 0 && (isDelivered === 0 || isDelivered === 1)) {
                await axios.post(`/delivery/delivered/${this.id}`, { delivered: isDelivered });
                this.deliveryDelivered = isDelivered === 1 ? true : false;
            }
        },
        async save() {
            // debugger;
            this.isSaving = true;

            let delivery = this.deliveryEvent.delivery;
            delivery.start = moment(this.deliveryEvent.start).unix();
            delivery.end = moment(this.deliveryEvent.end).unix();

            delivery.resources = this.resources.filter((r) => r.usage > 0);

            try {
                if (this.id == 0) {
                    await axios.put(`/delivery`, delivery);
                } else {
                    await axios.post(`/delivery/${this.id}`, delivery);
                }
            } catch (error) {
                this.isSaving = false;

                this.$store.commit("snackbar", {
                    text: "Feil oppstått - leveranse ikke lagret.",
                    color: "error",
                    show: true,
                });
                return;
            }

            this.$store.commit("snackbar", {
                text: "Leveranse lagret.",
                color: "success",
                show: true,
            });

            this.$router.push({ path: "/calendar" });
            this.isSaving = false;
        },
        async deleteDelivery() {
            let response = await this.axios.delete(`/delivery/${this.id}`);

            if (response.data.success) {
                this.showDeleteDialog = false;
                this.$router.push({ name: "deliveries" });

                this.$store.commit("snackbar", {
                    text: "Leveranse slettet.",
                    color: "success",
                    show: true,
                });
            } else {
                this.$store.commit("snackbar", {
                    text: "Leveranse ikke slettet.",
                    color: "error",
                    show: true,
                });
            }
        },
        async listSiteplans() {
            let files = await this.$store.dispatch("listFiles", "siteplans");
            files.forEach(async (file) => {
                await this.$store.dispatch("addFile", file);
                if (!this.$store.getters.file(file.name).src) {
                    let { binary, buffer, src, blob, url } = await this.$store.dispatch("downloadFile", file.name);

                    this.$set(file, "binary", binary);
                    this.$set(file, "buffer", buffer);
                    this.$set(file, "src", src);
                    this.$set(file, "blob", blob);
                    this.$set(file, "url", url);
                    await this.$store.dispatch("addFile", file);
                }
            });
        },
    },
    watch: {
        resources: {
            handler() {
                this.checkConstraints();
            },
            deep: true,
        },
        "delivery.zone": {
            handler() {
                this.checkConstraints();
            },
        },
        deliveryDate: {
            async handler() {
                this.deliveryEvent.start = moment(`${this.deliveryDate} ${this.deliveryStartTime}`).format("YYYY-MM-DD HH:mm");
                this.deliveryEvent.end = moment(`${this.deliveryDate} ${this.deliveryEndTime}`).format("YYYY-MM-DD HH:mm");

                this.deliveryEvents.splice(0);

                this.deliveries = await this.downloadDeliveries(this.deliveryDate, this.id);
                let deliveryEvents = this.convertDeliveriesToEvents(this.deliveries);
                deliveryEvents.push(this.deliveryEvent);

                this.deliveryEvents = deliveryEvents;

                this.checkConstraints();
            },
        },
        deliveryStartTime: {
            handler() {
                clearTimeout(this.deliveryStartTimeTimeout);
                this.calendarLoading = true;
                this.deliveryStartTimeTimeout = setTimeout(() => {
                    if (moment(`${this.deliveryDate} ${this.deliveryStartTime}`).isAfter(moment(`${this.deliveryDate} ${this.deliveryEndTime}`).subtract(15, "minute"))) {
                        this.deliveryEndTime = moment(`${this.deliveryDate} ${this.deliveryStartTime}`).add(15, "minute").format("HH:mm");
                    }

                    this.deliveryEvent.start = moment(`${this.deliveryDate} ${this.deliveryStartTime}`).format("YYYY-MM-DD HH:mm");

                    this.checkConstraints();
                    this.calendarLoading = false;
                }, 1000);
            },
        },
        deliveryEndTime: {
            handler() {
                clearTimeout(this.deliveryEndTimeTimeout);
                this.calendarLoading = true;
                this.deliveryEndTimeTimeout = setTimeout(() => {
                    if (moment(`${this.deliveryDate} ${this.deliveryEndTime}`).isBefore(moment(`${this.deliveryDate} ${this.deliveryStartTime}`).add(15, "minute"))) {
                        this.deliveryStartTime = moment(`${this.deliveryDate} ${this.deliveryEndTime}`).subtract(15, "minute").format("HH:mm");
                    }

                    this.deliveryEvent.end = moment(`${this.deliveryDate} ${this.deliveryEndTime}`).format("YYYY-MM-DD HH:mm");

                    this.checkConstraints();
                    this.calendarLoading = false;
                }, 1000);
            },
        },
    },
    async beforeMount() {
        this.delivery = this.createDelivery();
        this.deliveryEvents.push(this.convertDeliveryToEvent(this.delivery));
        this.loading = true;
    },
    async mounted() {
        this.deliveryEvents.splice(0);

        if (this.$refs.cal) {
            this.$refs.cal.scrollToTime({ hour: 6, minute: 30 });
        }

        if (!this.id || this.id == 0) {
            this.delivery = this.createDelivery();
        } else {
            this.delivery = await this.downloadDelivery(this.id);
        }

        // set date and time
        this.deliveryDate = moment.unix(this.delivery.start).format("YYYY-MM-DD");
        this.deliveryStartTime = moment.unix(this.delivery.start).format("HH:mm");
        this.deliveryEndTime = moment.unix(this.delivery.end).format("HH:mm");

        this.deliveries = await this.downloadDeliveries(this.deliveryDate, this.id);

        let deliveryEvent = this.convertDeliveryToEvent(this.delivery);
        let deliveryEvents = this.convertDeliveriesToEvents(this.deliveries);

        deliveryEvents.push(deliveryEvent);

        this.$set(this, "deliveryEvent", deliveryEvent);
        this.$set(this, "deliveryEvents", deliveryEvents);

        this.suppliers = await this.downloadSuppliers();
        this.users = await this.downloadUsers();

        // if zone is disabled, but a existing delivery uses it... then allow the zone
        if (this.delivery.id > 0 && this.delivery.zone && this.delivery.zone.disable) {
            this.zones = (await this.downloadZones()).filter((z) => {
                if (this.delivery.zone.id === z.id) return true;

                return z.disable !== 1 && z.disable !== true;
            });
        } else {
            this.zones = (await this.downloadZones()).filter((z) => z.disable !== 1 && z.disable !== true);
        }

        this.resources = await this.downloadResources();
        this.resources.forEach((r) => {
            let resource = this.delivery.resources.find((_r) => _r.id === r.id);
            if (resource) {
                this.$set(r, "usage", resource.usage);
                return;
            }
            this.$set(r, "usage", 0);
        });

        this.loading = false;

        this.listSiteplans();
    },
    beforeRouteEnter(to, from, next) {
        next((vue) => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
</style>